import React from 'react';

import {
  Text,
  PlayerImg,
  Testimony,
  CardPlayer,
  PlayerInfo,
  PlayerName,
  PlayerPosition,
} from './styles';

import Logo from '../../assets/icons/BDGLogo.png';

export default () => {
  return (
    <Testimony>
      <Text>
      “Our whole staff was able to recognize the reasoning behind our decisions to alter the lifting and throwing schedules.
      The pitching coaches had an understanding of how to adjust throwing. The strength coaches had an understanding of which 
      exercises to prescribe. The therapists knew what tissues to work on.”        
      </Text>
      <CardPlayer>
        <PlayerImg src={Logo} alt="Baseball Development Group" />
        <PlayerInfo>
          <PlayerName>
            Dr. Tyler Dobos & Lennon Richards
          </PlayerName>
          <PlayerPosition>
            Baseball Development Group
          </PlayerPosition>
        </PlayerInfo>
      </CardPlayer>
    </Testimony>
  )
};